import CONST from '../../CONST';

export default function getPlatform() {
    return CONST.PLATFORM.WEB;
}
